import React, { useContext } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import Context from "../ProductsProvider";

//style rules
import { Colors, Typography } from "../../../styles";

const CardMeta = ({region, price}) => {
	const { data: { language } } = useContext(Context);

	const renderRegion = () => {
		if (!region) return null;

		return <CardMetaText>{ region }</CardMetaText>;
	}

	const renderPrice = () => {
		if (!price) return null;

		if (language === "en") return <CardMetaText> | { price }</CardMetaText>;
		return <CardMetaText> | { price }</CardMetaText>;
	}
	
	return  (
		<CardMetaContainer>
			{renderRegion()}
			{renderPrice()}
		</CardMetaContainer>
	);
}

CardMeta.propTypes = {
	region: PropTypes.object,
	price: PropTypes.number,
};

export default CardMeta;

const CardMetaContainer = styled.div`
	margin-top: 1.5rem;
	padding: 0 1.4rem;
`;

const CardMetaText = styled.span`
	font-size: 1.3rem;
	font-weight: ${Typography.fontWeight.medium};
	line-height: 1.5rem;
	color: ${Colors.base.black};
`;
